// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import VTooltip from 'v-tooltip'
import router from './router'
import Lang from '../lang/global.lang'
import VModal from 'vue-js-modal'
import Carvue from 'carvue'
import 'carvue/dist/carvue.min.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faCalendarPlus, faCalendarMinus, faPlusCircle, faPlusSquare, faPlus, faArrowUp, faArrowDown, faTruckMoving, faUserMd } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faCoffee, faCalendarPlus, faCalendarMinus, faPlusCircle, faPlusSquare, faPlus, faArrowUp, faArrowDown, faTruckMoving, faUserMd)
Vue.component('font-awesome-icon', FontAwesomeIcon)
import Vuetify from 'vuetify'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Vuetify)
Vue.use(Datetime)
Vue.use(Carvue)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(VTooltip)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VModal)

const i18n = new VueI18n({
  locale: 'en',
  messages: Lang
})

new Vue({
  router,
  i18n,
  el: '#app',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js